const my_profile = {
  viewMyClubSeacretProfile: "Lihat Profil ClubSecret Saya", // translated
  viewMoreDetails: "Lihat Lebih Detail", // translated
  verifiedEmail: "Email Terverifikasi", // translated
  unverifiedEmail: "Email Belum Diverifikasi", // translated
  balance: "Keseimbangan", // translated
  pointsIn: "Poin Masuk", // translated
  pointsOut: "Menunjukkan", // translated
  topUp: "Isi Ulang", // translated
  pointsHistoryTable: "Tabel Riwayat Poin", // translated
  createdFrom: "Dibuat dari", // translated
  createdTo: "Dibuat hingga", // translated
  selectStatus: "Pilih status...", // translated
  searchByTitle: "Cari berdasarkan judul...", // translated
  pushNotifications: "Notifikasi Push", // translated 
  pushNotificationsDescription: "Terima notifikasi browser untuk pembaruan dan acara penting", // translated 
  pushNotificationsNotSupported: "Notifikasi push tidak didukung di browser ini", // translated 
  pushNotificationsDeniedMessage: "Izin notifikasi ditolak. Harap aktifkan notifikasi di pengaturan browser untuk menerima notifikasi push.", // translated 
  pushNotificationsEnabled: "Notifikasi push berhasil diaktifkan", // translated 
  pushNotificationsDisabled: "Notifikasi push berhasil dinonaktifkan", // translated 
  userInformationMissing: "Informasi pengguna hilang", // translated 
  failedToUpdatePushNotifications: "Gagal memperbarui pengaturan notifikasi push", // translated 
  notificationPermissionDenied: "Izin notifikasi ditolak. Harap aktifkan di pengaturan browser.", // translated 
  notificationPermissionRequired: "Izin notifikasi diaktifkan untuk mengaktifkan notifikasi push", // translated 
  notSupported: "Tidak didukung", // translated 
  permissionDenied: "Izinkan ditolak", // translated 
  permissionNotRequested: "Izin tidak diminta", // translated 
  enabled: "Diaktifkan", // translated 
  disabled: "Didh", // translated 
};


export default my_profile;
